import { render } from "./ViewCategorieArticle.vue?vue&type=template&id=49586eb7&ts=true"
import script from "./ViewCategorieArticle.vue?vue&type=script&lang=ts"
export * from "./ViewCategorieArticle.vue?vue&type=script&lang=ts"

import "./ViewCategorieArticle.vue?vue&type=style&index=0&id=49586eb7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__